import ajax from "@/toremove/components/octolo/base/ajax.js";
import auth from "@/toremove/components/octolo/base/auth.js";
import colors from "@/toremove/components/octolo/base/colors.js";
import crumbs from "@/toremove/components/octolo/base/crumbs.js";
import modal from "@/toremove/components/octolo/base/modal.js";
import shorts from "@/toremove/components/octolo/base/shorts.js";
import config from "@/toremove/components/octolo/base/config.js";
import translate from "@/toremove/components/octolo/base/translate.js";

export default {
    mixins: [config, translate,  ajax, auth, colors, crumbs, modal, shorts],
}
